export const MARKETPLACE_EMBED = 'marketplace-embed';
export const CONTENT_CREATOR = `${MARKETPLACE_EMBED}::content-creator`;